import Sidebar from "../components/Sidebar.js";
import Header from "../components/Header.js";
import remarksData from "../components/remarks.json";

let ddmmyyyy = function (dateObj) {
  var mm = dateObj.getMonth() + 1; // getMonth() is zero-based
  var dd = dateObj.getDate();

  return [
    (dd > 9 ? "" : "0") + dd,
    (mm > 9 ? "" : "0") + mm,
    dateObj.getFullYear(),
  ].join("-");
};

function RemarkDetail({ id }) {
  const obj = remarksData.filter((data) => data.id === id)[0];

  return (
    <div className="App flex flex-row">
      <Sidebar />
      <div className="container py-8 px-[5rem] bg-[#fbfbfb]">
        <Header title={"Remarks"} date="Sunday, 22 Dec 2024" colour="#c82333" />
        <h2 className="text-lg font-semibold mb-4 text-[#585858]">
          Managers Feedback:
        </h2>
        <div className="flex flex-row justify-between py-6 px-8 rounded-2xl outline-2 outline-gray-200 text-[#585858] bg-white">
          <div className="flex flex-col gap-6 max-w-[50rem]">
            <div>
              <p className="text-sm font-[500]">Company:</p>
              <p className="text-lg">{obj.companyName}</p>
            </div>

            <div>
              <p className="text-sm font-[500]">Feedback Title:</p>
              <p className="text-lg">{obj.feedbackTitle}</p>
            </div>
            <div>
              <p className="text-sm font-[500]">Detailed Feedback:</p>
              <p className="text-lg">{obj.detailedFeedback}</p>
            </div>
            <div>
              <p className="text-sm font-[500]">Suggested Corrections:</p>
              <p className="text-lg">{obj.suggestiveCorrections}</p>
            </div>
          </div>
          <p>Date: {ddmmyyyy(new Date(obj.date))}</p>
        </div>
      </div>
    </div>
  );
}

export default RemarkDetail;
